import ExportTracking from "@/types/tracking/exportTracking"
import ExportExpenditure from "@/types/expenditure/exportExpenditure"

export function exportTrackedTimesToCsv (filename: string, rows: ExportTracking[], total: string, totalTime: number, headers: string[], totalTitle: string) {
  const csvContent = createCsvContent(rows, headers, totalTitle, total, totalTime)
  downloadFile(csvContent, filename)
}

export function exportExpendituresToCsv (filename: string, rows: ExportExpenditure[], total: string, headers: string[], totalTitel: string) {
  const csvContent = createCsvContent(rows, headers, totalTitel, total)
  downloadFile(csvContent, filename)
}

function createCsvContent (rows: any, headers: string[], totalTitle: string, total: string, totalTime?: number) {
  if (!rows || !rows.length || !headers || !headers.length) return
  const separator = ","
  const keys: string[] = Object.keys(rows[0])
  const totalTimeCalc = totalTime || ','
  const csvContent =
    headers.join(separator) +
    '\n' +
    rows.map((row: any) => {
      return keys.map((k: any) => {
        let cell = row[k] === null || row[k] === undefined ? '' : row[k]

        cell = cell instanceof Date
          ? cell.toLocaleString()
          : cell.toString().replace(/"/g, '""')

        if (cell.search(/("|,|\n)/g) >= 0) {
          cell = `"${cell}"`
        }
        return cell
      }).join(separator)
    }).join('\n') +
    '\n' +
    totalTitle + headers.map(() => { return '' }).join(separator).slice(0, -1) + `"${totalTimeCalc}"` + separator + `"${total}"`
  return csvContent
}

function downloadFile (content: any, filename: string) {
  const blob = new Blob([content], { type: 'text/csvcharset=utf-8' })
  if (navigator.msSaveBlob) { // In case of IE 10+
    navigator.msSaveBlob(blob, filename)
  } else {
    const link = document.createElement('a')
    if (link.download !== undefined) {
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
